// extracted by mini-css-extract-plugin
export default {"modalNotiExam":"ModalMyExamNotification_modalNotiExam__Hhji3","btn":"ModalMyExamNotification_btn__l+-FF"};